export default __webpack_public_path__ + "static/media/avatarr.7c280fa6.jpg";